import React from "react";
import { createSvgIcon } from "@material-ui/core";

export default createSvgIcon(
  <path d="M22,17v3a2,2,0,0,1-2,2H4a2,2,0,0,1-2-2V17a1,1,0,0,1,1-1H3a1,1,0,0,1,1,1v3H20V17a1,1,0,0,1,1-1h0A1,1,0,0,1,22,17Zm-9-3.41L15.59,11A1,1,0,0,1,17,11h0a1,1,0,0,1,0,1.41l-4.29,4.3a1,1,0,0,1-1.42,0L7,12.41A1,1,0,0,1,7,11H7a1,1,0,0,1,1.41,0L11,13.59V3a1,1,0,0,1,1-1h0a1,1,0,0,1,1,1Z" />,
  "GuardianDownload"
);
